import React from "react";
import { createRoot } from "react-dom/client";

import { HomepageStage } from "./components/HomepageStage";

const homepageRootId = "homepage";
const homepageRoot = document.getElementById(homepageRootId);

if (homepageRoot) {
  createRoot(homepageRoot).render(<HomepageStage />);
} else {
  throw new Error(`#${homepageRootId} element not found`);
}
